import { useTexts } from "hooks/useTexts";
import React from "react";
import arrowCollapse from "static/icons/arrow-back-small.svg";
import arrowFullscreen from "static/icons/arrow-open-small.svg";
import arrowExpand from "static/icons/arrow-open-small.svg";

type ToggleIconProps = {
  isMobile: boolean;
  expanded: boolean;
};

const ToggleIcon: React.FC<ToggleIconProps> = ({ isMobile, expanded }) => {
  const { txt } = useTexts("card");

  if (isMobile)
    return (
      <img
        src={arrowFullscreen}
        alt={txt("expand", "Развернуть")}
      />
    );
  if (expanded)
    return (
      <img
        src={arrowCollapse}
        alt={txt("collapse", "Свернуть")}
      />
    );

  return (
    <img
      src={arrowExpand}
      alt={txt("expand", "Развернуть")}
    />
  );
};

export default ToggleIcon;
